module.exports = __webpack_public_path__ + "static/img/shenghuo_duihuan.4cf09309.png";